var chunkToChildrenMap = {
	"3453": [
		5608
	],
	"6528": [
		3453,
		3699,
		5717
	],
	"8400": [
		6528
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));